module.exports = __webpack_public_path__ + "static/img/joinBanner2.1dcd4d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/join/joinBanner2.jpg
// module id = fUkx
// module chunks = 0